module.exports = require('./dist/lib/error')



//////////////////
// WEBPACK FOOTER
// ../node_modules/next/error.js
// module id = ../node_modules/next/error.js
// module chunks = 2